<template>
    <div class="app">
        <header>
            <i class="el-icon-arrow-left"  @click="$router.go(-1)"></i>
            <span class="pageTitle">活动详情</span>
        </header>
        <div class="content">
            <div class="blank"></div>
            <div class="minContent">
                <div class="activityTitle">{{ activity.name }}</div>
                <div class="activityImg">
                    <img :src="activity.picName" alt="">
                </div>
                <div class="activityInfo">
                    <ul>
                        <li>
                            <div class="itemInfo">
                                <span>活动标题：</span>
                                <span>{{ activity.name }}</span>
                            </div>
                        </li>
                        <li>
                            <div class="itemInfo">
                                <span>活动时间：</span>
                                <span>{{ activity.beginTime | moment('YYYY年MM月DD日') }}-{{ activity.endTime | moment('YYYY年MM月DD日') }}</span>
                            </div>
                        </li>
                        <li>
                            <div class="itemInfo">
                                <span>参与店铺：</span>
                                <span>{{ activity.name }}</span>
                            </div>
                        </li>
                        <li>
                            <div class="itemInfo">
                                <span>店铺地址：</span>
                                <span>{{ activity.address }}</span>
                            </div>
                        </li>
                        <li>
                            <div class="itemInfo">
                                <span>联系电话：</span>
                                <span>{{ activity.name }}</span>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="activityContent">
                    <div class="activityDetail">
                        {{ activity.description }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import { Toast } from "mint-ui"
import { showActivityAction } from '../../assets/js/api'

export default {
  data() {
    return {
        activity: [], // 活动详情
        sid: 0,
    };
  },
  computed: {
   
  },
  methods: {
      getActivityInfo () {
          showActivityAction(this.sid).then ( res => {
              if (res.s == 0) {
                  this.activity = res.Activity
              }
          })
      }
  },
  created () {
    this.sid = this.$route.query.sid
  },
  mounted () {
      this.getActivityInfo()
  }
};
</script>
<style scoped>
.app {
  width: 100%;
  height: 100%;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
}
header {
  height: 1.5rem;
  width: 100%;
  background-image: linear-gradient(-134deg, #299ead 0%, #299ead 100%);
  position: fixed;
  z-index: 1;
}
.blank {
  height: 1.5rem;
  width: 100%;
}
.pageTitle {
  font-size: 0.5rem;
  text-align: center;
  color: white;
  position: absolute;
  top: 50%;
  left: 38%;
  transform: translateY(-50%);
}
.el-icon-arrow-left {
  font-size: 0.7rem;
  color: white;
  position: absolute;
  top: 50%;
  transform: translate(50%, -50%);
}
.content {
  position: absolute;
  flex: 1;
  background-color: rgba(241, 241, 241, 1);
  height: 100%;
  width: 100%;
  overflow-x: hidden;
}
i.el-icon-arrow-right {
  float: right;
  color: rgba(0, 0, 0, 1);
  margin-top: 0.5rem;
  font-size: 0.55rem;
  margin-right: 0.6rem;
}
.minContent{
    width: 100%;
    height: 13.56rem;
    background-color: #fff;
    margin-top: 0.26rem;
}
.activityTitle{
    width: 100%;
    height: 1.13rem;
    text-align: center;
    line-height: 0.53rem;
    font-size: 0.47rem;
    color: rgba(0, 0, 0, 0.7);
    padding-top: 0.32rem;
}
.activityImg img{
    width: 9.11rem;
    height: 4.29rem;
    margin-left: 0.26rem;
}
.activityInfo{
    margin-top: 0.16rem;
    border-bottom: 0.03rem solid rgba(0, 0, 0, 0.1);
}
.itemInfo{
    height: 0.61rem;
    font-size: 0.42rem;
    color: rgba(0, 0, 0, 0.7);
    line-height: 0.53rem;
    border-bottom: 0.03rem solid rgba(0, 0, 0, 0.1);
    margin-left: 0.53rem;
}
.activityDetail{
    width: 6.87rem;
    height: 3.39rem;
    font-size: 0.37rem;
    color: rgba(136, 136, 136, 1);
    line-height: 0.53rem;
    border: 0.03rem solid rgba(187, 187, 187, 1);
    margin-top: 0.26rem;
    margin-left: 0.58rem;
    padding-top: 0.29rem;
    padding-left: 0.32rem;
    padding-right: 1.6rem;
    overflow-x: hidden;
    overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/cardBag/activityDetail.vue